/**
 * Custom Set accepts exactly one range: "2-5".
 * Returns an error message, or null when valid.
 */
export function validateCustomRange(expression: string, totalPages: number): string | null {
  const value = expression.trim();

  if (!value) return 'Enter a page range like 2-5';

  const match = /^(\d+)-(\d+)$/.exec(value);
  if (!match) return 'Use a single range like 2-5 (no commas)';

  const from = Number(match[1]);
  const to = Number(match[2]);

  if (from < 1) return 'Pages start at 1';
  if (from > to) return 'Start page must not be greater than end page';
  if (to > totalPages) return `This document has only ${totalPages} pages`;

  return null;
}